module.exports = __webpack_public_path__ + "img/COK.a0411791.svg";